import { InputTypes } from "../InputTypes";
import { OptionsSources } from "../OptionsSources";
import { Aliment } from "../aliments/Aliment";

export function defaultUnitsInputData() {
  let defaultUnits = ["g", "ml"];

  let unitsData = defaultUnits.map((unit) => {
    return { value: unit, label: unit };
  });
  return unitsData;
}

export const IngredientGroup = Object.freeze({
  max_weight: {
    visibleName: "Peso máximo del grupo",
    type: InputTypes.NUMBER,
    min: 0,
  },
  visible_name: {
    visibleName: "Nombre visible del grupo",
    type: InputTypes.TEXT,
    required: false,
  },
  group_preparation: {
    visibleName: "Preparación base del grupo",
    type: InputTypes.TEXT_AREA,
    required: false,
  },
  min_amount: {
    visibleName: "Cantidad mínima total",
    type: InputTypes.NUMBER,
    min: 0,
    required: false,
  },
  max_amount: {
    visibleName: "Cantidad máxima total",
    type: InputTypes.NUMBER,
    min: 0,
    required: false,
  },
  /*   units: {
    visibleName: "Unidades totales",
    type: InputTypes.SELECT,
    optionsMapping: {
      source: OptionsSources.INLINE,
      options: defaultUnitsInputData(),
    },
    required: false,
  }, */
});
